import { Snowflake, Droplets } from "lucide-react";
import { Label } from "@/components/ui/label";

export const FishCondition = ({ value, testId }) => (!value ? null : (
  <span className={`ml-1.5 inline-flex items-center gap-0.5 text-[10px] font-semibold rounded-full px-1.5 py-0.5 border align-middle ${value === "frozen" ? "bg-sky-50 text-sky-700 border-sky-200" : "bg-teal-50 text-teal-700 border-teal-200"}`} data-testid={testId}>
    {value === "frozen" ? <Snowflake className="h-3 w-3" /> : <Droplets className="h-3 w-3" />}{value === "frozen" ? "Frozen" : "Basah"}
  </span>
));

export function FishConditionPicker({ value, onChange, testId = "fish-condition", compact = false }) {
  const opts = [{ v: "frozen", label: "Frozen", Icon: Snowflake, on: "bg-sky-600 text-white border-sky-600" }, { v: "basah", label: "Basah", Icon: Droplets, on: "bg-teal-600 text-white border-teal-600" }];
  return (
    <div className="space-y-1.5">
      {!compact && <Label>Status Ikan</Label>}
      <div className="flex gap-1.5" role="radiogroup" data-testid={testId}>
        {opts.map(({ v, label, Icon, on }) => (
          <button key={v} type="button" role="radio" aria-checked={value === v} onClick={() => onChange(v)}
            className={`flex-1 inline-flex items-center justify-center gap-1 rounded-md border font-semibold transition-colors ${compact ? "h-9 px-2 text-xs" : "h-10 px-3 text-sm"} ${value === v ? on : "bg-white text-slate-600 border-slate-200 hover:bg-slate-50"}`}
            data-testid={`${testId}-${v}`}><Icon className="h-3.5 w-3.5" />{label}</button>
        ))}
      </div>
    </div>
  );
}
